import { ArrowClockwiseIcon } from '@phosphor-icons/react';

import { TextButton } from '@/components/common/text-button';

import styles from './region-error.module.scss';

export type RegionErrorProps = {
  /** What failed, in the house `We couldn't load your <thing>. Please try again.` voice. */
  message: string;
  onRetry: () => void;
};

/**
 * A region's failure state: the notice and the retry that re-requests **only that region**
 * (ADR-0027 §5 — a Dashboard's cards row, each graph and the counts fail and recover
 * independently; ADR-0029 — the Customer Map's map-data load does the same over a live canvas).
 *
 * Named for the one state it renders. It owns no loading state and never will: each region's
 * skeleton has to occupy that region's own shape so the page settles once rather than jumping,
 * and a five-tile grid, a chart-height block and a map canvas have nothing to share.
 */
export function RegionError({ message, onRetry }: RegionErrorProps) {
  return (
    <div className={styles.notice}>
      <p className={styles.noticeText}>{message}</p>
      <TextButton
        tone="brand"
        size="sm"
        startIcon={<ArrowClockwiseIcon size={16} />}
        onClick={onRetry}
      >
        Try again
      </TextButton>
    </div>
  );
}
